import { Box, Grid } from "@mantine/core";

import { MainLayout } from "../../layouts/MainLayout";
import { Statistics } from "../../widgets/dashboard/Statistics";
import { CurrentGoals } from "../../widgets/dashboard/CurrentGoals";
import { RecomendedCourses } from "../../widgets/dashboard/RecomendedCourses";
import { useMediaQuery } from "@mantine/hooks";
import useAuthStore from "../../store/useAuthStore";
import useDashboardStore from "../../store/useDashboardStore";
import { useEffect, useState } from "react";
import useCoursesStore from "../../store/useCoursesStore";
import { ReusableOnboardingTour } from "../../utils/components/onboardingTour/OnboardingTourWrapper";
import useProfileStore from "../../store/useProfileStore";
import { OnboardingTourFocusRevealProps } from "@gfazioli/mantine-onboarding-tour";
import { useOnboardingDashboardSteps } from "../../utils/onboardingTourSteps";
import { scrollToTop } from "../../utils/helpers";
import { TourButton } from "../../utils/components/onboardingTour/TourButton";

export const Dashboard = () => {
  const laptop = useMediaQuery("(max-width: 1100px)");
  const mobile = useMediaQuery("(max-width: 820px)");

  const { profile, tourButtonShow, fetchProfile } = useProfileStore();
  const steps = useOnboardingDashboardSteps();

  const { access_token, isRefreshing } = useAuthStore();
  const { fetchDashboard } = useDashboardStore();
  const {
    fetchRecommendedCourses,
    recommendedCourses,
    learningCourses,
    fetchLearningCourses,
  } = useCoursesStore();

  const [started, setStarted] = useState(false);

  useEffect(() => {
    if (!profile) fetchProfile();
  }, []);

  useEffect(() => {
    if (
      profile?.display_preferences?.hide_tour_tooltip_on_dashboard !== null &&
      profile?.display_preferences?.hide_tour_tooltip_on_dashboard !== undefined
    )
      setStarted(!profile?.display_preferences?.hide_tour_tooltip_on_dashboard);
  }, [profile?.display_preferences?.hide_tour_tooltip_on_dashboard]);

  const focusRevealProps: OnboardingTourFocusRevealProps = {
    popoverProps: {
      arrowSize: 20,
      position: mobile ? "bottom" : "left",
    },
  };

  useEffect(() => {
    if (access_token && !isRefreshing) {
      fetchDashboard(access_token);
    }
  }, [access_token, isRefreshing]);

  useEffect(() => {
    if (access_token && recommendedCourses.results.length === 0) {
      fetchRecommendedCourses();
    }
  }, [access_token]);

  useEffect(() => {
    if (
      access_token &&
      learningCourses.results.length === 0 &&
      recommendedCourses.results.length > 0
    ) {
      fetchLearningCourses();
    }
  }, [recommendedCourses]);

  return (
    <MainLayout>
      <ReusableOnboardingTour
        focusRevealProps={focusRevealProps}
        tour={steps}
        started={started}
        onOnboardingTourEnd={() => {
          tourButtonShow({ hide_tour_tooltip_on_dashboard: true });
          scrollToTop();
        }}
        maw={mobile ? 300 : 235}
        __size="xs"
      >
        <Box m={mobile ? 16 : 40}>
          <Grid mb={laptop ? 24 : 32} gutter={laptop ? 24 : 32}>
            <Grid.Col span={laptop ? 12 : 6}>
              <Statistics />
            </Grid.Col>
            <Grid.Col span={laptop ? 12 : 6}>
              <CurrentGoals />
            </Grid.Col>
          </Grid>
          <RecomendedCourses />
        </Box>
      </ReusableOnboardingTour>
      <TourButton
        onClick={() => {
          tourButtonShow({ hide_tour_tooltip_on_dashboard: false });
        }}
      />
    </MainLayout>
  );
};
